import { render } from "./MessageView.vue?vue&type=template&id=2ed54198"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=2ed54198&lang=scss"
import "./MessageView.vue?vue&type=style&index=1&id=2ed54198&lang=scss"
import "./MessageView.vue?vue&type=style&index=2&id=2ed54198&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__